﻿let defaults = {
    AnnotationNode: {
        enabled: true,
        label: null,
        fontFamily: null,
        fontSize: 0.1,
        lineSpacing: 0,
        preloadFontStylesheet: "",
        color: {"$type":"KbColor","r":1.0,"g":1.0,"b":1.0,"a":1.0},
        targetId: null,
        billboard: false,
        isPickable: false,
        keepOnTop: false,
        lineStyle: "solid",
        horizontalTextAlign: "left",
        verticalBoxAlign: "middle",
        horizontalBoxAlign: "center",
        offset: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        name: null,
        metadata: {},
    },
    DimensionNode: {
        target2Id: null,
        lineCapStyle: "line",
        axis: "free",
        lineThickness: 0.05,
        dimensionGap: 0.1,
        dimensionUnitPrecision: 2,
        labelOffset: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        scaleWithCamera: false,
        enabled: true,
        label: null,
        fontFamily: null,
        fontSize: 0.1,
        lineSpacing: 0,
        preloadFontStylesheet: "",
        color: {"$type":"KbColor","r":1.0,"g":1.0,"b":1.0,"a":1.0},
        targetId: null,
        billboard: false,
        isPickable: false,
        keepOnTop: false,
        lineStyle: "solid",
        horizontalTextAlign: "left",
        verticalBoxAlign: "middle",
        horizontalBoxAlign: "center",
        offset: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        name: null,
        metadata: {},
    },
    BaseConnector: {
        positionMode: "boundingBox",
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        direction: {"$type":"KbVector","x":0.0,"y":1.0,"z":0.0},
        angle: 0,
        positionZeroToOne: 0,
        interpolateDirection: true,
        name: null,
        metadata: {},
    },
    Connector: {
        enabled: true,
        positionMode: "boundingBox",
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        direction: {"$type":"KbVector","x":0.0,"y":1.0,"z":0.0},
        angle: 0,
        positionZeroToOne: 0,
        interpolateDirection: true,
        name: null,
        metadata: {},
    },
    CircularPatternFeature: {
        arc: 360,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        axis: {"$type":"KbVector","x":0.0,"y":1.0,"z":0.0},
        count: 1,
        meshId: null,
        distance: 1,
        addEndMesh: false,
        enabled: true,
        name: null,
        metadata: {},
    },
    DeleteFacesFeature: {
        enabled: true,
        name: null,
        metadata: {},
    },
    DisplacementMapFeature: {
        minDisplacement: 0,
        maxDisplacement: 1,
        enabled: true,
        name: null,
        metadata: {},
    },
    ExtrudeFeature: {
        size: 0,
        capEnd: false,
        capStart: false,
        enabled: true,
        name: null,
        metadata: {},
    },
    Feature: {
        enabled: true,
        name: null,
        metadata: {},
    },
    JoinGeometryFeature: {
        joinType: "cut",
        meshId: null,
        enabled: true,
        name: null,
        metadata: {},
    },
    LinearPatternFeature: {
        translation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        count: 1,
        meshId: null,
        distance: 1,
        addEndMesh: false,
        enabled: true,
        name: null,
        metadata: {},
    },
    MirrorFeature: {
        cloneGeometry: false,
        intersect: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        normal: {"$type":"KbVector","x":1.0,"y":1.0,"z":1.0},
        removeGeometry: false,
        enabled: true,
        name: null,
        metadata: {},
    },
    MoveVerticesFeature: {
        translation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scale: {"$type":"KbVector","x":1.0,"y":1.0,"z":1.0},
        center: "barycenter",
        enabled: true,
        name: null,
        metadata: {},
    },
    NormalSmoothingFeature: {
        smooth: true,
        enabled: true,
        name: null,
        metadata: {},
    },
    PatternFeature: {
        count: 1,
        meshId: null,
        distance: 1,
        addEndMesh: false,
        enabled: true,
        name: null,
        metadata: {},
    },
    SliceFeature: {
        intersect: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        normal: {"$type":"KbVector","x":1.0,"y":1.0,"z":1.0},
        removeGeometry: false,
        enabled: true,
        name: null,
        metadata: {},
    },
    SubmeshFeature: {
        uvMapping: false,
        materialId: null,
        center: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        projectionAxis: {"$type":"KbVector","x":0.0,"y":1.0,"z":0.0},
        angle: 0,
        scale: {"$type":"KbVector","x":1.0,"y":1.0,"z":1.0},
        uTile: 1,
        vTile: 1,
        uOffset: 0,
        vOffset: 0,
        mode: "planar",
        enabled: true,
        name: null,
        metadata: {},
    },
    SweepFeature: {
        start: null,
        end: null,
        path: null,
        mitredExtrusion: false,
        size: 0,
        capEnd: false,
        capStart: false,
        enabled: true,
        name: null,
        metadata: {},
    },
    TransformFeature: {
        scale: {"$type":"KbVector","x":1.0,"y":1.0,"z":1.0},
        enabled: true,
        name: null,
        metadata: {},
    },
    UvMapFeature: {
        center: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        projectionAxis: {"$type":"KbVector","x":0.0,"y":1.0,"z":0.0},
        angle: 0,
        scale: {"$type":"KbVector","x":1.0,"y":1.0,"z":1.0},
        uTile: 1,
        vTile: 1,
        uOffset: 0,
        vOffset: 0,
        mode: "planar",
        enabled: true,
        name: null,
        metadata: {},
    },
    WeldVerticesFeature: {
        enabled: true,
        name: null,
        metadata: {},
    },
    Kb3dObject: {
        name: null,
        metadata: {},
    },
    DirectionalLightNode: {
        direction: {"$type":"KbVector","x":0.0,"y":1.0,"z":0.0},
        generatesShadows: false,
        shadowQuality: "medium",
        shadowResolution: "low",
        shadowFilter: "simple",
        processTransparency: false,
        intensity: 1,
        color: {"$type":"KbColor","r":0.0,"g":0.0,"b":0.0,"a":1.0},
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    HemisphericLightNode: {
        direction: {"$type":"KbVector","x":0.0,"y":1.0,"z":0.0},
        groundColor: {"$type":"KbColor","r":0.0,"g":0.0,"b":0.0,"a":1.0},
        intensity: 1,
        color: {"$type":"KbColor","r":0.0,"g":0.0,"b":0.0,"a":1.0},
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    LightNode: {
        intensity: 1,
        color: {"$type":"KbColor","r":0.0,"g":0.0,"b":0.0,"a":1.0},
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    PointLightNode: {
        generatesShadows: false,
        shadowQuality: "medium",
        shadowResolution: "low",
        shadowFilter: "simple",
        processTransparency: false,
        intensity: 1,
        color: {"$type":"KbColor","r":0.0,"g":0.0,"b":0.0,"a":1.0},
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    ShadowLightNode: {
        generatesShadows: false,
        shadowQuality: "medium",
        shadowResolution: "low",
        shadowFilter: "simple",
        processTransparency: false,
        intensity: 1,
        color: {"$type":"KbColor","r":0.0,"g":0.0,"b":0.0,"a":1.0},
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    SpotLightNode: {
        coneAngle: 60,
        direction: {"$type":"KbVector","x":0.0,"y":1.0,"z":0.0},
        generatesShadows: false,
        shadowQuality: "medium",
        shadowResolution: "low",
        shadowFilter: "simple",
        processTransparency: false,
        intensity: 1,
        color: {"$type":"KbColor","r":0.0,"g":0.0,"b":0.0,"a":1.0},
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    AdvancedMaterialNode: {
        workflowMode: "metallicRoughness",
        backFaceCulling: false,
        directIntensity: 1,
        emissiveIntensity: 1,
        environmentIntensity: 1,
        specularIntensity: 1,
        metallic: 0,
        roughness: 1,
        microSurface: 1,
        useSpecularOverAlpha: true,
        useRadianceOverAlpha: true,
        ambientColor: {"$type":"KbColor","r":1.0,"g":1.0,"b":1.0,"a":1.0},
        albedoColor: {"$type":"KbColor","r":1.0,"g":1.0,"b":1.0,"a":1.0},
        specularColor: {"$type":"KbColor","r":1.0,"g":1.0,"b":1.0,"a":1.0},
        reflectionColor: {"$type":"KbColor","r":1.0,"g":1.0,"b":1.0,"a":1.0},
        anisotropyEnabled: false,
        anisotropicDirection: {"$type":"KbVector","x":1.0,"y":1.0,"z":1.0},
        anisotropicIntensity: 1,
        subsurfaceThickness: 1,
        subsurfaceRefractionEnabled: false,
        subsurfaceReflectionEnabled: false,
        reflectionType: "plane",
        probePositionTargetId: null,
        subsurfaceRefractionIndex: 1,
        subsurfaceRefractionIntensity: 1,
        subsurfaceRefractionLinkTransparency: false,
        subsurfaceTranslucencyEnabled: false,
        subsurfaceTranslucencyIntensity: 1,
        subsurfaceUseAlbedoForTintColor: true,
        subsurfaceTintColor: {"$type":"KbColor","r":1.0,"g":1.0,"b":1.0,"a":1.0},
        clearcoatEnabled: false,
        clearcoatIntensity: 1,
        clearcoatTintEnabled: false,
        clearcoatTintColor: {"$type":"KbColor","r":1.0,"g":1.0,"b":1.0,"a":1.0},
        clearcoatTintIntensity: 0.1,
        archived: false,
        location: "local",
        alpha: 1,
        zOffset: 0,
        doubleSided: false,
        legacyTextureStacking: true,
        viewMode: "shaded",
        emissiveColor: {"$type":"KbColor","r":0.0,"g":0.0,"b":0.0,"a":1.0},
        hasTransparency: false,
        uOffset: 0,
        vOffset: 0,
        uScale: 1,
        vScale: 1,
        uAngle: 0,
        vAngle: 0,
        wAngle: 0,
        uPivot: 0.5,
        vPivot: 0.5,
        wPivot: 0.5,
        name: null,
        metadata: {},
    },
    ColorFillTextureLayer: {
        color: {"$type":"KbColor","r":0.0,"g":0.0,"b":0.0,"a":1.0},
        width: 256,
        height: 256,
        enabled: true,
        strength: 1,
        tile: false,
        maintainAspect: false,
        useClippingMask: false,
        blendMode: "normal",
        horizontalAlign: "center",
        verticalAlign: "middle",
        horizontalFit: "none",
        verticalFit: "none",
        uOffset: 0,
        vOffset: 0,
        uScale: 1,
        vScale: 1,
        uAngle: 0,
        vAngle: 0,
        wAngle: 0,
        uPivot: 0.5,
        vPivot: 0.5,
        wPivot: 0.5,
        name: null,
        metadata: {},
    },
    FileTextureLayer: {
        width: 256,
        height: 256,
        flipNormalsRg: false,
        enabled: true,
        strength: 1,
        tile: false,
        maintainAspect: false,
        useClippingMask: false,
        blendMode: "normal",
        horizontalAlign: "center",
        verticalAlign: "middle",
        horizontalFit: "none",
        verticalFit: "none",
        uOffset: 0,
        vOffset: 0,
        uScale: 1,
        vScale: 1,
        uAngle: 0,
        vAngle: 0,
        wAngle: 0,
        uPivot: 0.5,
        vPivot: 0.5,
        wPivot: 0.5,
        name: null,
        metadata: {},
    },
    MaterialMapping: {
        uOffset: 0,
        vOffset: 0,
        uScale: 1,
        vScale: 1,
        uAngle: 0,
        vAngle: 0,
        wAngle: 0,
        uPivot: 0.5,
        vPivot: 0.5,
        wPivot: 0.5,
        name: null,
        metadata: {},
    },
    MaterialNode: {
        location: "local",
        alpha: 1,
        zOffset: 0,
        reflectionType: "plane",
        doubleSided: false,
        legacyTextureStacking: true,
        viewMode: "shaded",
        emissiveColor: {"$type":"KbColor","r":0.0,"g":0.0,"b":0.0,"a":1.0},
        hasTransparency: false,
        uOffset: 0,
        vOffset: 0,
        uScale: 1,
        vScale: 1,
        uAngle: 0,
        vAngle: 0,
        wAngle: 0,
        uPivot: 0.5,
        vPivot: 0.5,
        wPivot: 0.5,
        name: null,
        metadata: {},
    },
    SvgTextureLayer: {
        width: 256,
        height: 256,
        preloadFontStylesheet: "",
        enabled: true,
        strength: 1,
        tile: false,
        maintainAspect: false,
        useClippingMask: false,
        blendMode: "normal",
        horizontalAlign: "center",
        verticalAlign: "middle",
        horizontalFit: "none",
        verticalFit: "none",
        uOffset: 0,
        vOffset: 0,
        uScale: 1,
        vScale: 1,
        uAngle: 0,
        vAngle: 0,
        wAngle: 0,
        uPivot: 0.5,
        vPivot: 0.5,
        wPivot: 0.5,
        name: null,
        metadata: {},
    },
    TextTextureLayer: {
        text: "",
        color: {"$type":"KbColor","r":1.0,"g":1.0,"b":1.0,"a":1.0},
        enabled: true,
        strength: 1,
        tile: false,
        maintainAspect: false,
        useClippingMask: false,
        blendMode: "normal",
        horizontalAlign: "center",
        verticalAlign: "middle",
        horizontalFit: "none",
        verticalFit: "none",
        uOffset: 0,
        vOffset: 0,
        uScale: 1,
        vScale: 1,
        uAngle: 0,
        vAngle: 0,
        wAngle: 0,
        uPivot: 0.5,
        vPivot: 0.5,
        wPivot: 0.5,
        name: null,
        metadata: {},
    },
    TextureLayer: {
        enabled: true,
        strength: 1,
        tile: false,
        maintainAspect: false,
        useClippingMask: false,
        blendMode: "normal",
        horizontalAlign: "center",
        verticalAlign: "middle",
        horizontalFit: "none",
        verticalFit: "none",
        uOffset: 0,
        vOffset: 0,
        uScale: 1,
        vScale: 1,
        uAngle: 0,
        vAngle: 0,
        wAngle: 0,
        uPivot: 0.5,
        vPivot: 0.5,
        wPivot: 0.5,
        name: null,
        metadata: {},
    },
    MateNode: {
        enabled: true,
        connector1: null,
        connector2: null,
        mateType: "fastened",
        flip: false,
        offsetX: 0,
        offsetY: 0,
        offsetZ: 0,
        offsetAngle: 0,
        name: null,
        metadata: {},
    },
    BoxNode: {
        height: 1,
        width: 1,
        depth: 1,
        tessellation: 1,
        sideOrientation: "frontSide",
        materialId: null,
        flipSurfaceOrientation: false,
        receiveShadows: false,
        castShadows: false,
        isPickable: true,
        checkCollisions: false,
        opacity: 1,
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    ConeNode: {
        height: 1,
        radiusTop: 0,
        radiusBottom: 0.5,
        tessellation: 24,
        sideOrientation: "frontSide",
        materialId: null,
        flipSurfaceOrientation: false,
        receiveShadows: false,
        castShadows: false,
        isPickable: true,
        checkCollisions: false,
        opacity: 1,
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    CustomMeshNode: {
        materialId: null,
        flipSurfaceOrientation: false,
        receiveShadows: false,
        castShadows: false,
        isPickable: true,
        checkCollisions: false,
        opacity: 1,
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    CylinderNode: {
        height: 1,
        radius: 0.5,
        arc: 360,
        tessellation: 24,
        subdivisions: 1,
        capMode: "both",
        sideOrientation: "frontSide",
        materialId: null,
        flipSurfaceOrientation: false,
        receiveShadows: false,
        castShadows: false,
        isPickable: true,
        checkCollisions: false,
        opacity: 1,
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    DiscNode: {
        radius: 0.5,
        tessellation: 64,
        sideOrientation: "frontSide",
        materialId: null,
        flipSurfaceOrientation: false,
        receiveShadows: false,
        castShadows: false,
        isPickable: true,
        checkCollisions: false,
        opacity: 1,
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    GroundNode: {
        height: 1,
        width: 1,
        subdivisions: 1,
        sideOrientation: "frontSide",
        materialId: null,
        flipSurfaceOrientation: false,
        receiveShadows: false,
        castShadows: false,
        isPickable: true,
        checkCollisions: false,
        opacity: 1,
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    MeshGroupNode: {
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    MeshNode: {
        materialId: null,
        flipSurfaceOrientation: false,
        receiveShadows: false,
        castShadows: false,
        isPickable: true,
        checkCollisions: false,
        opacity: 1,
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    PlaneNode: {
        depth: 4,
        width: 4,
        segments: 1,
        sideOrientation: "frontSide",
        materialId: null,
        flipSurfaceOrientation: false,
        receiveShadows: false,
        castShadows: false,
        isPickable: true,
        checkCollisions: false,
        opacity: 1,
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    PrimitiveMeshNode: {
        sideOrientation: "frontSide",
        materialId: null,
        flipSurfaceOrientation: false,
        receiveShadows: false,
        castShadows: false,
        isPickable: true,
        checkCollisions: false,
        opacity: 1,
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    SketchControlPoint: {
        positionMode: "absolute",
        direction2: {"$type":"KbVector","x":0.0,"y":-1.0,"z":0.0},
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        direction: {"$type":"KbVector","x":0.0,"y":1.0,"z":0.0},
        angle: 0,
        positionZeroToOne: 0,
        interpolateDirection: true,
        name: null,
        metadata: {},
    },
    SketchNode: {
        normal: "y",
        addFace: false,
        closePath: false,
        tracePath: false,
        lineThickness: 1,
        pathColor: {"$type":"KbColor","r":1.0,"g":1.0,"b":1.0,"a":1.0},
        flipPath: false,
        clonePath: null,
        boundingXOverride: null,
        boundingYOverride: null,
        boundingZOverride: null,
        materialId: null,
        flipSurfaceOrientation: false,
        receiveShadows: false,
        castShadows: false,
        isPickable: true,
        checkCollisions: false,
        opacity: 1,
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    SketchPath: {
        pathGroupKey: "default",
        holeForPathGroup: null,
        type: "points",
        tessellation: 16,
        name: null,
        metadata: {},
    },
    SpaceNode: {
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    SphereNode: {
        tessellation: 32,
        radius: 0.5,
        latitudeStart: 0,
        latitudeSlice: 180,
        arc: 360,
        sideOrientation: "frontSide",
        materialId: null,
        flipSurfaceOrientation: false,
        receiveShadows: false,
        castShadows: false,
        isPickable: true,
        checkCollisions: false,
        opacity: 1,
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    TextNode: {
        curveRadius: 0,
        charSpacing: 1,
        text: "",
        fontFile: "",
        fontSize: 1,
        materialId: null,
        flipSurfaceOrientation: false,
        receiveShadows: false,
        castShadows: false,
        isPickable: true,
        checkCollisions: false,
        opacity: 1,
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    TorusNode: {
        radius: 0.5,
        thickness: 0.25,
        arc: 360,
        latitudeStart: 0,
        latitudeSlice: 360,
        tessellation: 16,
        sideOrientation: "frontSide",
        materialId: null,
        flipSurfaceOrientation: false,
        receiveShadows: false,
        castShadows: false,
        isPickable: true,
        checkCollisions: false,
        opacity: 1,
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    SceneNode: {
        background: "transparent",
        environment: "library://adams_place_bridge",
        environmentBlur: 0.27,
        environmentIntensity: 1,
        backgroundColor: {"$type":"KbColor","r":0.0,"g":0.0,"b":0.0,"a":0.0},
        ambientColor: {"$type":"KbColor","r":0.0,"g":0.0,"b":0.0,"a":1.0},
        renderMode: "shaded",
        edgeColor: {"$type":"KbColor","r":1.0,"g":1.0,"b":1.0,"a":1.0},
        edgeWidth: 1,
        edgeDisplayTolerance: 0.95,
        viewpointId: null,
        frameViewpoint: false,
        progressiveTextureLoad: true,
        enableDeferredSceneUpdates: true,
        enableGrid: false,
        enableGridAxes: false,
        gridSize: 10,
        gridStepSize: 1,
        gridMajorInterval: 1,
        gridNormal: "y",
        environmentRotation: 0,
        connectorSize: 0.1,
        enableFxaaPostProcess: false,
        enableLensEffectsPostProcess: false,
        enableSSAOPostProcess: false,
        textureSamplingMode: "trilinear",
        fullscreenEnabled: true,
        arEnabled: true,
        xrAllowScaling: false,
        unitsPerMeter: 1,
        xrAddShadow: true,
        xrLightingEstimation: false,
        enableHoverEffects: false,
        enableSceneOptimization: true,
        loadingExperience: "spinner",
        loadingImagePath: null,
        dimensionUnitScalar: 1,
        dimensionUnitSymbol: "m",
        conversionMap: {},
        visible: true,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        useEuler: false,
        eulerRotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAxis: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        rotationAngle: 0,
        scaling: 1,
        pivot: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fixed: false,
        name: null,
        metadata: {},
    },
    ViewpointNode: {
        type: "orbit",
        targetMode: "point",
        projection: "perspective",
        offsetX: 0,
        offsetY: 0,
        position: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        targetPoint: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        targetMeshId: null,
        rotation: {"$type":"KbVector","x":0.0,"y":0.0,"z":0.0},
        fov: 50,
        allowOrbit: true,
        allowPan: true,
        allowZoom: true,
        limitMinimumTargetDistance: false,
        minTargetDistance: 0.001,
        maxTargetDistance: 10000,
        orbitAxis: {"$type":"KbVector","x":0.0,"y":1.0,"z":0.0},
        limitLatOrbit: false,
        limitMinLatitude: 0,
        limitMaxLatitude: 180,
        limitLngOrbit: false,
        limitMinLongitude: -180,
        limitMaxLongitude: 180,
        name: null,
        metadata: {},
    },
};
export { defaults };